import { Controller } from "@hotwired/stimulus"

// Reemplaza los toasts de Materialize. Se auto-oculta salvo que sea un error.
export default class extends Controller {
  static values = { dismissAfter: { type: Number, default: 6000 } }

  connect() {
    if (this.dismissAfterValue > 0) {
      this.timeout = setTimeout(() => this.dismiss(), this.dismissAfterValue)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    // Los avisos viven abajo (#flash): salen hacia abajo.
    this.element.classList.add("opacity-0", "translate-y-2")
    setTimeout(() => this.element.remove(), 200)
  }
}
